module.exports = __webpack_public_path__ + "img/intro10.699dfd9d.jpg";